import React, { useEffect, useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { hasModuleAccess } from "../helpers/rbac_helper";

const Navdata = () => {
    const history = useNavigate();
    //state data
    const [isDashboard, setIsDashboard] = useState(false);
    const [isOldReference, setIsOldReference] = useState(false);
    const [isApps, setIsApps] = useState(false);
    const [isAuth, setIsAuth] = useState(false);
    const [isPages, setIsPages] = useState(false);
    const [isBaseUi, setIsBaseUi] = useState(false);
    const [isAdvanceUi, setIsAdvanceUi] = useState(false);
    const [isForms, setIsForms] = useState(false);
    const [isTables, setIsTables] = useState(false);
    const [isCharts, setIsCharts] = useState(false);
    const [isIcons, setIsIcons] = useState(false);
    const [isMaps, setIsMaps] = useState(false);
    const [isMultiLevel, setIsMultiLevel] = useState(false);

    //Calender
    const [isCalender, setCalender] = useState(false);

    // Apps
    const [isEmail, setEmail] = useState(false);
    const [isSubEmail, setSubEmail] = useState(false);
    const [isEcommerce, setIsEcommerce] = useState(false);
    const [isProjects, setIsProjects] = useState(false);
    const [isTasks, setIsTasks] = useState(false);
    const [isCRM, setIsCRM] = useState(false);
    const [isCrypto, setIsCrypto] = useState(false);
    const [isInvoices, setIsInvoices] = useState(false);
    const [isSupportTickets, setIsSupportTickets] = useState(false);
    const [isNFTMarketplace, setIsNFTMarketplace] = useState(false);
    const [isLanding, setIsLanding] = useState(false);
    const [isJobs, setIsJobs] = useState(false);
    const [isJobList, setIsJobList] = useState(false);
    const [isCandidateList, setIsCandidateList] = useState(false);

    // Authentication
    const [isSignIn, setIsSignIn] = useState(false);
    const [isSignUp, setIsSignUp] = useState(false);
    const [isPasswordReset, setIsPasswordReset] = useState(false);
    const [isPasswordCreate, setIsPasswordCreate] = useState(false);
    const [isLockScreen, setIsLockScreen] = useState(false);
    const [isLogout, setIsLogout] = useState(false);
    const [isSuccessMessage, setIsSuccessMessage] = useState(false);
    const [isVerification, setIsVerification] = useState(false);
    const [isError, setIsError] = useState(false);

    // Pages
    const [isProfile, setIsProfile] = useState(false);
    const [isBlog, setIsBlog] = useState(false);

    // Charts
    const [isApex, setIsApex] = useState(false);

    // Multi Level
    const [isLevel1, setIsLevel1] = useState(false);
    const [isLevel2, setIsLevel2] = useState(false);

    // New Menu Items
    const [isImport, setIsImport] = useState(false);
    const [isSettings, setIsSettings] = useState(false);
    const [isFruits, setIsFruits] = useState(false);
    const [isInvoiceSettings, setIsInvoiceSettings] = useState(false);
    const [isReports, setIsReports] = useState(false);

    const [iscurrentState, setIscurrentState] = useState('Dashboard');

    function updateIconSidebar(e) {
        if (e && e.target && e.target.getAttribute("subitems")) {
            const ul = document.getElementById("two-column-menu");
            const iconItems = ul.querySelectorAll(".nav-icon.active");
            let activeIconItems = [...iconItems];
            activeIconItems.forEach((item) => {
                item.classList.remove("active");
                var id = item.getAttribute("subitems");
                if (document.getElementById(id))
                    document.getElementById(id).classList.remove("show");
            });
        }
    }

    useEffect(() => {
        document.body.classList.remove('twocolumn-panel');
        
        // Define child states that belong to OldReference
        const oldReferenceChildStates = ['Apps', 'Auth', 'Pages', 'Landing', 'BaseUi', 'AdvanceUi', 'Forms', 'Tables', 'Charts', 'Icons', 'Maps', 'MuliLevel'];
        
        if (iscurrentState !== 'Dashboard') {
            setIsDashboard(false);
        }
        // Keep OldReference open if current state is a child of OldReference
        if (iscurrentState !== 'OldReference' && !oldReferenceChildStates.includes(iscurrentState)) {
            setIsOldReference(false);
        } else if (oldReferenceChildStates.includes(iscurrentState)) {
            // Keep OldReference open when navigating to its child states
            setIsOldReference(true);
        }
        // Keep Apps menu open if current state is Apps OR if any of its child states are active
        const hasActiveAppsChild = isCalender || isEmail || isSubEmail || isEcommerce || isProjects || 
                                   isTasks || isCRM || isCrypto || isInvoices || isSupportTickets || 
                                   isNFTMarketplace || isJobs || isJobList || isCandidateList;
        if (iscurrentState !== 'Apps' && !hasActiveAppsChild) {
            setIsApps(false);
        } else if (iscurrentState === 'Apps' || hasActiveAppsChild) {
            setIsApps(true);
        }
        // Keep Auth menu open if current state is Auth OR if any of its child states are active
        const hasActiveAuthChild = isSignIn || isSignUp || isPasswordReset || isPasswordCreate || 
                                   isLockScreen || isLogout || isSuccessMessage || isVerification || isError;
        if (iscurrentState !== 'Auth' && !hasActiveAuthChild) {
            setIsAuth(false);
        } else if (iscurrentState === 'Auth' || hasActiveAuthChild) {
            setIsAuth(true);
        }
        // Keep Pages menu open if current state is Pages OR if any of its child states are active
        const hasActivePagesChild = isProfile || isBlog;
        if (iscurrentState !== 'Pages' && !hasActivePagesChild) {
            setIsPages(false);
        } else if (iscurrentState === 'Pages' || hasActivePagesChild) {
            setIsPages(true);
        }
        if (iscurrentState !== 'Landing') {
            setIsLanding(false);
        }
        if (iscurrentState !== 'BaseUi') {
            setIsBaseUi(false);
        }
        if (iscurrentState !== 'AdvanceUi') {
            setIsAdvanceUi(false);
        }
        if (iscurrentState !== 'Forms') {
            setIsForms(false);
        }
        if (iscurrentState !== 'Tables') {
            setIsTables(false);
        }
        // Keep Charts menu open if current state is Charts OR if any of its child states are active
        const hasActiveChartsChild = isApex;
        if (iscurrentState !== 'Charts' && !hasActiveChartsChild) {
            setIsCharts(false);
        } else if (iscurrentState === 'Charts' || hasActiveChartsChild) {
            setIsCharts(true);
        }
        if (iscurrentState !== 'Icons') {
            setIsIcons(false);
        }
        if (iscurrentState !== 'Maps') {
            setIsMaps(false);
        }
        // Keep MultiLevel menu open if current state is MuliLevel OR if any of its child states are active
        const hasActiveMultiLevelChild = isLevel1 || isLevel2;
        if (iscurrentState !== 'MuliLevel' && !hasActiveMultiLevelChild) {
            setIsMultiLevel(false);
        } else if (iscurrentState === 'MuliLevel' || hasActiveMultiLevelChild) {
            setIsMultiLevel(true);
        }
        // Keep Import menu open if current state is Import
        if (iscurrentState !== 'Import') {
            setIsImport(false);
        } else {
            setIsImport(true);
        }
        // Keep Settings menu open if current state is Settings OR if any of its child states are active
        const hasActiveSettingsChild = isFruits || isInvoiceSettings;
        if (iscurrentState !== 'Settings' && !hasActiveSettingsChild) {
            setIsSettings(false);
        } else if (iscurrentState === 'Settings' || hasActiveSettingsChild) {
            setIsSettings(true);
        }
        if (iscurrentState === 'Widgets') {
            history("/widgets");
            document.body.classList.add('twocolumn-panel');
        }
    }, [
        history,
        iscurrentState,
        isDashboard,
        isOldReference,
        isApps,
        isAuth,
        isPages,
        isBaseUi,
        isAdvanceUi,
        isForms,
        isTables,
        isCharts,
        isIcons,
        isMaps,
        isMultiLevel,
        isImport,
        isSettings,
        isCalender,
        isEmail,
        isSubEmail,
        isEcommerce,
        isProjects,
        isTasks,
        isCRM,
        isCrypto,
        isInvoices,
        isSupportTickets,
        isNFTMarketplace,
        isJobs,
        isJobList,
        isCandidateList,
        isSignIn,
        isSignUp,
        isPasswordReset,
        isPasswordCreate,
        isLockScreen,
        isLogout,
        isSuccessMessage,
        isVerification,
        isError,
        isProfile,
        isBlog,
        isApex,
        isLevel1,
        isLevel2,
        isFruits,
        isInvoiceSettings,
        isReports
    ]);

    const menuItems = [
        {
            id: "dashboard",
            label: "Dashboard",
            icon: "ri-dashboard-2-line",
            link: "/dashboard",
        },
        {
            id: "partyManagement",
            label: "Party Management",
            icon: "ri-group-line",
            link: "/party-management",
        },
        {
            id: "import",
            label: "Import",
            icon: "ri-download-line",
            link: "/import",
        },
        {
            id: "export",
            label: "Export",
            icon: "ri-upload-line",
            link: "/export",
        },
        {
            id: "miscellaneous",
            label: "Miscellaneous",
            icon: "ri-more-line",
            link: "/miscellaneous",
        },
        {
            id: "reports",
            label: "Reports",
            icon: "ri-file-chart-line",
            link: "/#",
            click: function (e) {
                e.preventDefault();
                const newReportsState = !isReports;
                setIsReports(newReportsState);
                if (newReportsState) {
                    setIscurrentState('Reports');
                } else {
                    setIscurrentState('Dashboard');
                }
                updateIconSidebar(e);
            },
            stateVariables: isReports,
            subItems: [
                {
                    id: "invoiceLedger",
                    label: "Ledger",
                    link: "/invoice-ledger",
                    parentId: "reports",
                },
            ],
        },
        {
            id: "userSettings",
            label: "User Settings",
            icon: "ri-user-settings-line",
            link: "/user-settings",
        },
        {
            id: "roleManagement",
            label: "Role Management",
            icon: "ri-shield-user-line",
            link: "/settings-role-management",
        },
        {
            id: "settings",
            label: "Settings",
            icon: "ri-settings-3-line",
            link: "/#",
            click: function (e) {
                e.preventDefault();
                const newSettingsState = !isSettings;
                setIsSettings(newSettingsState);
                // Only set current state to 'Settings' when opening, reset when closing
                if (newSettingsState) {
                    setIscurrentState('Settings');
                } else {
                    setIscurrentState('Dashboard');
                }
                updateIconSidebar(e);
            },
            stateVariables: isSettings,
            subItems: [
                {
                    id: "profileSettings",
                    label: "Profile Settings",
                    link: "/settings-profile-settings",
                    parentId: "settings",
                },
                {
                    id: "fruits",
                    label: "Fruits",
                    link: "/settings-fruits-items",
                    parentId: "settings",
                },
                {
                    id: "invoiceSettings",
                    label: "Invoice",
                    link: "/settings-invoice",
                    parentId: "settings",
                },
                {
                    id: "shippingPort",
                    label: "Shipping Port",
                    link: "/settings-shipping-port",
                    parentId: "settings",
                },
                {
                    id: "logs",
                    label: "Logs",
                    link: "/settings-logs",
                    parentId: "settings",
                },
            ],
        },
    ];

    // Filter menu items based on user permissions
    const filteredMenuItems = useMemo(() => {
        const baseFilteredItems = menuItems;

        try {
            // Filter based on permissions - no bypass, hasAccess must be true
            return baseFilteredItems.filter(item => {
                // Always show header items
                if (item.isHeader) {
                    return true;
                }

                const moduleId = item.id;

                // Check if user has hasAccess for this module
                if (hasModuleAccess(moduleId)) {
                    return true;
                }

                // If item has subitems, show if any subitem has access
                if (item.subItems && item.subItems.length > 0) {
                    const hasAccessibleSub = item.subItems.some(subItem =>
                        hasModuleAccess(subItem.id) || hasModuleAccess(subItem.parentId)
                    );
                    return hasAccessibleSub;
                }

                return false;
            });
        } catch (error) {
            // If any error occurs in RBAC logic, show all menus
            console.error('RBAC Error:', error);
            return baseFilteredItems;
        }
    }, [menuItems]);

    return <React.Fragment>{filteredMenuItems}</React.Fragment>;
};
export default Navdata;